import { FormControl, Validators } from '@angular/forms';

import * as RegexPattern from '@teem/constants/regex-patterns';
import { User } from '@teem/models/user';

export class UserForm {
	uuid = new FormControl();
	first_name = new FormControl('', [Validators.required,Validators.maxLength(99)]);
	last_name = new FormControl('',[Validators.maxLength(99)]);
	email = new FormControl('', [Validators.required,Validators.email]);
	phone = new FormControl('', [Validators.required,Validators.maxLength(10)]);
	password = new FormControl('', [Validators.minLength(6)]);
	confirm_password = new FormControl('', [Validators.minLength(6)]);
	business_name = new FormControl();
	user_type = new FormControl('', [Validators.required]);
	
	constructor(user: User) {
		if (user) {
			if (user.uuid) {
				this.uuid.setValue(user.uuid)
			}
			this.first_name.setValue(user.first_name);
			this.last_name.setValue(user.last_name);
			this.email.setValue(user.email);
			this.phone.setValue(user.phone);
			this.user_type.setValue(user.user_type);
			this.business_name.setValue(user.business_name);
		}
	}
}
